import * as maptilersdk from '@maptiler/sdk';

export const BaseMaps = {
    STREETS: {
        img: 'maptiler/streets.png',
        style: maptilersdk.MapStyle.STREETS,
    },
    SATELLITE: {
        img: 'maptiler/satellite.png',
        style: maptilersdk.MapStyle.SATELLITE,
    },
    DATAVIZ: {
        img: 'maptiler/light.png',
        style: maptilersdk.MapStyle.DATAVIZ.LIGHT,
    },
    CADASTRE: {
        img: 'maptiler/cadastre.png',
        style: 'cadastre',
    },
};

export const getDefaultMap = () => {
    return Object.values(BaseMaps)[0];
};

export const ControlPosition = Object.freeze({
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
});
